export default {
    keysfobs_tab_hex: 'Identifier',
    keysfobs_tab_driver: 'Driver',
    keysfobs_tab_account: 'Account',
    keysfobs_tab_model: 'Model'
};
